import * as React from "react";
import { useRef } from "react";
import { Button, FormControl, InputGroup } from "components/bootstrap";
const ServiceAccountKeyFilePicker = ({ fileName = void 0, onFileRead }) => {
  const fileInputRef = useRef(null);
  const handleFileChange = (event) => {
    var _a;
    const { target } = event;
    const file = (_a = target.files) == null ? void 0 : _a[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => onFileRead(String(reader.result), file.name);
    reader.readAsText(file);
    target.value = "";
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(InputGroup, null, /* @__PURE__ */ React.createElement(InputGroup.Button, null, /* @__PURE__ */ React.createElement(Button, { type: "button", onClick: () => {
    var _a;
    return (_a = fileInputRef.current) == null ? void 0 : _a.click();
  } }, "Browse...")), /* @__PURE__ */ React.createElement(
    FormControl,
    {
      type: "text",
      value: fileName != null ? fileName : "",
      onChange: () => {
      },
      onClick: () => {
        var _a;
        return (_a = fileInputRef.current) == null ? void 0 : _a.click();
      },
      tabIndex: -1,
      placeholder: "No file selected."
    }
  )), /* @__PURE__ */ React.createElement(
    "input",
    {
      ref: fileInputRef,
      type: "file",
      accept: "application/json",
      "aria-label": "Service Account Key file",
      style: { display: "none" },
      onChange: handleFileChange
    }
  ));
};
export default ServiceAccountKeyFilePicker;
